import { FC } from 'react';
import { ReactComponent as Logo } from 'assets/images/logo.svg';

const Loader: FC = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-primary-2 p-6">
    <div className="inline-flex w-[150px] animate-heartbeat">
      <Logo />
    </div>
  </div>
);

export default Loader;
